export const FETCH_PROFILE = 'FETCH_PROFILE'
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE'
export const RECEIVE_ROLES = 'RECEIVE_ROLES'
export const RECEIVE_DASHBOARDS = 'RECEIVE_DASHBOARDS'
export const RECEIVE_TERMS = 'RECEIVE_TERMS'
export const RECEIVE_BUSSINES_CODE = 'RECEIVE_BUSSINES_CODE'
export const CLEAR_ALL = 'CLEAR_ALL'
